import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { variables } from '../../../assets/styles/variables';
import themeColors from '../../../assets/styles/themeColors';
import { pxToRem } from '../../../assets/styles/helper';

const RibbonElement = styled.div`
  font-size: ${({ fontSize }) => fontSize || pxToRem(12)};
  background-color: ${({ bgColor }) => bgColor || themeColors.colorSuccess};
  color: ${({ color }) => color || themeColors.colorWhite};
  font-family: ${variables.family.goldSilverHeaders};
  border-radius: 0 3px 0 2px;
  position: absolute;
  top: 0;
  right: 0;
  padding: 4px 6px;
`;

const Ribbon = ({ children, color, bgColor, fontSize }) => (
  <RibbonElement color={color} bgColor={bgColor} fontSize={fontSize}>
    {children}
  </RibbonElement>
);

Ribbon.propTypes = {
  children: PropTypes.node,
  color: PropTypes.string,
  bgColor: PropTypes.string,
  fontSize: PropTypes.number,
};

export default Ribbon;
